// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cloudBasePath: 'https://d257ngkbdt8gs0.cloudfront.net/git',
  translationsPath: 'https://d257ngkbdt8gs0.cloudfront.net/template/i18n/halo/',
  servicePath: 'https://vtqa.lfconnect.com/lfservice/api',
  currentHostPath: 'https://vtqa.lfconnect.com/web',
  oamHostPath: 'https://oamn.lifefitness.com',
  assetsPath: './assets',
  IPstackKey: '35d3e627c464cf7ef5996734521adea5',
  SSOformAuthRedirectionUrl: 'https://oamn.lifefitness.com/oam/server/authentication',
  ssoPartsUrl: 'https://external-xtst.lifefitness.com',
  amplitudeAPI: '0ac9f015ad3aafab1cb5f5a2fca42553',
  membrHostPath: 'https://stage-api.membraws.com/api/lfconnect/redirect',
  appEngineServiceBasePath: 'https://register-equipment-dot-lfco-qa-191202.appspot.com',
  s3CloudBasePath: 'https://qaweb-static.halo.fitness',
  tncBasePath: 'https://d2rphhwi1n9zjn.cloudfront.net/template',
  haloWebCloudBasePath: 'https://d2rphhwi1n9zjn.cloudfront.net',
  retentionUrl: 'https://staging-cdn.fitconnect.io/lf/index.html',
  pearStudioURL: 'https://lf-studio-staging.pearsports.com/halo-signin?token=',
  pearBuilderURL: 'https://pearpro-lf-staging.pearsports.com/halo-signin?token=',
  gcpServicePath: 'https://springboot-haloweb-vtqa-yjuvivvkga-uc.a.run.app/api/v1',
  zendeskURL: 'https://lifefitness9512.zendesk.com/hc/en-us/articles/6916317796887',
  apigeeCMSUrl: 'https://api-vtqa.halo.fitness/managerapi/cms/v4',
  apigeeCMSTempUrl: 'https://us-central1-servicenotices-dev.cloudfunctions.net',
  apiKey: '3yXBN3MQ6APKA1c3BShx4gwmKpWQJne4',
  envkey_mux: '1uii4h7shdi9cf4dpahpjlpkv',
  gcpBasePath: 'https://vtqa-webapi.lfconnect.com',
  assetsUrl: 'https://vtqa-halo5app1.halo.fitness/assets',
  fcConnectHostPath: 'https://stg.facility.lifefitness.com/web/dashboard',
  fcConnectDownloadSoftwarePath: 'https://stg.facility.lifefitness.com/static-apps/download-software',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
